<template>
  <v-container v-if="!is_open && !is_error" fill-heght>
    <div style="width:50px; height:50px; position:absolute; top:50%; left:50%; transform: translate(-50%, -50%);">
      <div class="spinner" />
    </div>
  </v-container>
  <v-container v-else-if="is_error" fill-heght>
    <div style="width:250px; height:50px; position:absolute; top:50%; left:50%; transform: translate(-50%, -50%); text-align:center;">
      {{ $t('progress.error') }}
    </div>
  </v-container>
  <v-container v-else fluid style="height:100%; background:linear-gradient(rgb(255, 255, 255), rgb(245, 249, 250));">
    <v-row align="center" justify="center" style="height:100%;">
      <v-col cols="12" sm="8" md="6" lg="4" xl="3">
        <v-card class="px-5 py-10" outlined>
          <v-form ref="form">
            <v-row align="center">
              <v-col>
                <div style="color:#808080; font-size:20px; text-align: center;">
                  <p>{{ $t('progress.title') }}</p>
                </div>
              </v-col>
            </v-row>
            <v-divider class="my-2"></v-divider>
            <v-row align="center">
              <v-col cols="5">
                <div>{{ $t('progress.requestDate') }}</div>
              </v-col>
              <v-col cols="7">
                <v-select v-model="request_date" @change="result_preview" dense outlined hide-details :items="request_date_list" :no-data-text="$t('progress.noData')"></v-select>
              </v-col>
            </v-row>
            <v-divider class="my-2"></v-divider>
            <v-row align="center">
              <v-col cols="5">
                <div>{{ $t('progress.barcodeId') }}</div>
              </v-col>
              <v-col cols="7">
                <div style="font-weight:bold;">{{ patient_id }}</div>
              </v-col>
            </v-row>
            <v-divider class="my-2"></v-divider>
            <v-row align="center">
              <v-col cols="5">
                <div>{{ $t('progress.name') }}</div>
              </v-col>
              <v-col cols="7">
                <div style="font-weight:bold;">{{ patient_name }}</div>
              </v-col>
            </v-row>
            <v-divider class="my-2"></v-divider>
            <v-row align="center">
              <v-col cols="5">
                <div>{{ $t('progress.progress') }}</div>
              </v-col>
              <v-col cols="7">
                <div style="font-weight:bold;">{{ progress }}</div>
              </v-col>
            </v-row>
            <v-divider class="my-2"></v-divider>
            <v-row align="center">
              <v-col cols="5">
                <div>{{ $t('progress.forecastDate') }}</div>
              </v-col>
              <v-col cols="7">
                <div style="font-weight:bold;">{{dateformat(forecast_date)}}</div>
              </v-col>
            </v-row>
            <v-divider class="my-2"></v-divider>
            <v-row align="center">
              <v-col cols="5">
                <div>{{ $t('progress.actualDate') }}</div>
              </v-col>
              <v-col cols="7">
                <div style="font-weight:bold;">{{dateformat(finsh_date)}}</div>
              </v-col>
            </v-row>
            <v-divider class="my-2"></v-divider>
            <v-row align="center">
              <v-col cols="5">
                <div>{{ $t('progress.reportDate') }}</div>
              </v-col>
              <v-col cols="7">
                <div style="font-weight:bold;">{{ dateformat(create_date) }}</div>
              </v-col>
            </v-row>
            <v-divider class="my-2"></v-divider>
            <v-row align="center">
              <v-col>
                <v-btn @click="print_result" :color="!!finsh_date?'':'grey'" :ripple="!!finsh_date" dark block :elevation="0">{{ $t('progress.viewReport') }}</v-btn>
              </v-col>
            </v-row>
            <div v-if="request_date_list&&request_date_list.length>0" class="mt-3" style="color:#acacac; font-size:10pt;">
              <div>
                {{ $t('progress.inquiry') }}
              </div>
              <div style="text-align:center;">
                csdev@hlscience.com
              </div>
            </div>
            <div v-else class="mt-3" style="color:red; font-size:10pt; text-align: center;">
              {{ $t('progress.noResult') }}
            </div>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import http from '@/mixin/http'
import validation from '@/mixin/validation'
export default {
  name: 'progress-vue',
  mixins: [validation, http],
  data:()=>({
    is_open: false,
    is_error: false,

    patient_id: null,
    patient_name: null,
    request_date: null,

    forecast_date: null,
    progress: null,
    finsh_date: null,
    create_date: null,
    now_request_date: null,

    template_version: '2',  //default 2

    request_date_list: [],
  }),
  created:async function(){
    if ( !this.$route.query.patient_id || !this.$route.query.patient_name ){
      alert(this.$t('progress.invalidAccess'));
      this.$session.destroy();
      this.$router.replace({name:"Login"});
      return;
    }
    this.patient_id = decodeURI(this.$route.query.patient_id);
    this.patient_name = decodeURI(this.$route.query.patient_name);
    this.get_request_date_combo().then(res=>{
      this.is_open = res;
    })
  },
  methods:{
    dateformat: function(str){
      if ( !str ) return;
      let date = new Date(str);
      let year = date.getFullYear();
      let month = date.getMonth()+1;
      let day = date.getDate();
      const isEng = this.$i18n.locale === 'eng';
      if ( isEng ){
        const monthName = this.$t('common.monthNames.' + month) || month;
        return monthName + ' ' + day + ', ' + year;
      }
      let res = "";
      if ( year ){
        res += ( year + this.$t('common.year'));
      }
      if ( month ){
        res += ( ' ' + month + this.$t('common.month'));
      }
      if ( day ){
        if ( day < 10 ){
          day = '0' + day;
        }
        res += ( ' ' + day + this.$t('common.day'));
      }
      return res;
    },
    print_result:async function(){
      if ( this.request_date_list.lenght <= 0 ) return;
      if ( !this.finsh_date ) {
        alert(this.$t('progress.resultNotReady'));
        return;
      }
      await this.get_result_template();
      let data = {
        headers:{
          jwt: this.$session.get("jwt")
        },
        param:[{
          patient_id: this.patient_id,
          request_date: this.request_date,
        }],
        template_version: this.template_version,
        expire: new Date().getTime()+1800000  //expire time : now() + 30min
      };
      let query_string = "?data=" + btoa(JSON.stringify(data));
      if ( this.template_version*1 == 4 ){
        window.open(process.env.NODE_ENV==='development'?"http://localhost:8081/v4"+query_string:"https://hlgenecheck.com/v4"+query_string, "", "");
      }
      else if ( this.template_version*1 == 6 || this.template_version*1 == 8 ){
        window.open(process.env.NODE_ENV==='development'?"http://localhost:8081/v5"+query_string:"https://hlgenecheck.com/v5"+query_string, "", "");
      }
      else if ( this.template_version*1 == 7 ){  //영문 version 1
        window.open(process.env.NODE_ENV==='development'?"http://localhost:8081/eng/v1"+query_string:"https://hlgenecheck.com/eng/v1"+query_string, "", "");
      }
      else {
        window.open(process.env.NODE_ENV==='development'?"http://localhost:8081/viewer"+query_string:"https://hlgenecheck.com/viewer"+query_string, "", "");
      }
    },
    result_preview: async function(){
      let data = {
        patient_id: this.patient_id,
        request_date: this.request_date
      };
      let res = await this.get(this.$lookupUrl + '/server/result_preview.php', data);
      if ( res ){
        this.forecast_date = res.data.info.forecast_date;
        this.progress = res.data.info.progress;
        this.finsh_date = res.data.info.finsh_date;
        this.create_date = res.data.info.create_date;
        this.now_request_date = res.data.info.now_request_date;
      }
    },
    get_request_date_combo:async function(){
      let is_success = false;
      let data = {
        patient_id: this.patient_id
      };
      let res = await this.get(this.$lookupUrl + '/server/result/get_request_date_combo.php', data);
      if ( res ){
        res.data.info.forEach(element=>{
          this.request_date_list.push(element.request_date);
        })
        if ( this.request_date_list && this.request_date_list.length > 0 ){
          this.request_date = this.request_date_list[0];
          this.result_preview();
        }
        is_success = true;
      }
      else{
        this.is_error = true;
      }
      return is_success;
    },
    get_result_template:async function(){
      //템플릿 버전별 시작일자, 종료일자를 조회 하여 request_date가 포함되는 템플릿 버전을 세팅한다.
      //현재는 버전 1, 버전 2, 버전 4, 버전 6만 존재함.
      let data = {
        request_date: this.request_date,
        lang_cd: this.$store.getters.lang_cd
      };
      let res = await this.get(this.$lookupUrl + '/server/result/get_template_list.php', data);
      if ( res ){
        if ( res.data.ret == "0000" ){
          let template_info = res.data.info[0];
          this.template_version = template_info.seq;
        }
      }
    },
  }
}
</script>
